import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FeedbackHistoryRow from './FeedbackHistoryRow';
import './FeedbackHistory.scss';

const displayedStatuses = ['interview_requested', 'rejected', 'employer_accepted',
  'submitted_to_employer', 'drafting'];

const renderRow = (item) => displayedStatuses.includes(item.new_status);

const tableHeading = (
  <tr className="heading">
    <th colSpan="4">Feedback</th>
    <th colSpan="2">Status</th>
    <th colSpan="2">User</th>
    <th colSpan="2">Date</th>
    <th colSpan="2" />
    <th colSpan="2" />
  </tr>
);

class FeedbackHistory extends Component {
  renderFeedbackItem(item) {
    const {
      csrfToken,
      proposalResourceId,
      consultant,
      clorifyUrl,
      reasonOptions,
      internalFeedbackText,
      advisorRemark,
    } = this.props;
    let type;
    let status;

    switch (item.new_status) {
      case 'interview_requested':
        type = 'interview';
        status = 'Interview Requested';
        break;
      case 'interview_in_progress':
        type = 'interview';
        status = 'Interview in Progress';
        break;
      case 'interview_completed':
        type = 'interview';
        status = 'Interview Completed';
        break;
      case 'rejected':
        type = 'decline';
        status = 'Declined';
        break;
      case 'employer_accepted':
        type = 'hire';
        status = 'Hired';
        break;
      case 'submitted_to_employer':
        type = 'submitted';
        status = 'Submitted';
        break;
      case 'drafting':
        type = 'drafting';
        status = 'Drafting';
        break;
      default:
        break;
    }

    return (
      <FeedbackHistoryRow
        item={item}
        csrfToken={csrfToken}
        proposalResourceId={proposalResourceId}
        consultant={consultant}
        clorifyUrl={clorifyUrl}
        reasonOptions={reasonOptions}
        key={item.id}
        type={type}
        status={status}
        internalFeedbackText={internalFeedbackText}
        advisorRemark={advisorRemark}
      />
    );
  }

  render() {
    const { feedbackItems } = this.props;

    return (
      <div className="feedback-history-container">
        <table className="feedback-items-table">
          <tbody>
            {tableHeading}
            {feedbackItems.map((item) => renderRow(item) && this.renderFeedbackItem(item))}
          </tbody>
        </table>
      </div>
    );
  }
}

FeedbackHistory.propTypes = {
  feedbackItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  consultant: PropTypes.shape({}).isRequired,
  clorifyUrl: PropTypes.string.isRequired,
  internalFeedbackText: PropTypes.string,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advisorRemark: PropTypes.string,
};

FeedbackHistory.defaultProps = {
  internalFeedbackText: null,
  advisorRemark: null,
};

export default FeedbackHistory;
